import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Fade,
  Zoom,
  Backdrop,
  Stack,
  Avatar,
} from "@mui/material";
import { CheckCircle, Celebration, ArrowForward } from "@mui/icons-material";

const CreateSuccessfulTimeTable = () => {
  const navigate = useNavigate();

  return (
    <Dialog
      open={true}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: "visible",
          bgcolor: "transparent",
          boxShadow: "none",
        },
      }}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(8px)",
          },
        },
      }}
    >
      <Fade in={true} timeout={400}>
        <Box>
          <Zoom in={true} timeout={500}>
            <Box
              sx={{
                position: "relative",
                bgcolor: "#ffffff",
                borderRadius: 4,
                p: 1,
                boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
                overflow: "hidden",
              }}
            >
              {/* Top decorative gradient bar */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 5,
                  background:
                    "linear-gradient(90deg, #f77f00, #ffb74d, #f77f00)",
                  backgroundSize: "200% 100%",
                  animation: "shimmer 2s infinite linear",
                  "@keyframes shimmer": {
                    "0%": { backgroundPosition: "200% 0" },
                    "100%": { backgroundPosition: "-200% 0" },
                  },
                }}
              />

              {/* Floating celebration icons background */}
              <Celebration
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 20,
                  color: "#fff3e0",
                  fontSize: 80,
                  transform: "rotate(15deg)",
                  opacity: 0.6,
                }}
              />
              <Celebration
                sx={{
                  position: "absolute",
                  bottom: 60,
                  left: 16,
                  color: "#fff3e0",
                  fontSize: 60,
                  transform: "rotate(-20deg)",
                  opacity: 0.5,
                }}
              />

              <DialogContent sx={{ p: 4, pt: 5, textAlign: "center" }}>
                <Stack spacing={3} alignItems="center">
                  {/* Animated Success Avatar */}
                  <Box
                    sx={{
                      position: "relative",
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        top: -8,
                        left: -8,
                        right: -8,
                        bottom: -8,
                        borderRadius: "50%",
                        border: "3px solid #fff3e0",
                        animation:
                          "pulse-ring 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite",
                        "@keyframes pulse-ring": {
                          "0%": { transform: "scale(0.8)", opacity: 1 },
                          "100%": { transform: "scale(1.3)", opacity: 0 },
                        },
                      },
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 90,
                        height: 90,
                        bgcolor: "#fff3e0",
                        boxShadow: "0 8px 24px rgba(247,127,0,0.25)",
                      }}
                    >
                      <CheckCircle
                        sx={{
                          fontSize: 50,
                          color: "#f77f00",
                          animation:
                            "popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                          "@keyframes popIn": {
                            "0%": { transform: "scale(0)", opacity: 0 },
                            "100%": { transform: "scale(1)", opacity: 1 },
                          },
                        }}
                      />
                    </Avatar>
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="h5"
                    fontWeight={800}
                    color="#2d3436"
                    sx={{ letterSpacing: "-0.5px" }}
                  >
                    Published Successfully!
                  </Typography>

                  {/* Message */}
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      maxWidth: 280,
                      lineHeight: 1.7,
                      fontSize: "1.05rem",
                    }}
                  >
                    You have successfully published the class timetable.
                  </Typography>

                  {/* Action Button */}
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => navigate("/lactureManagement")}
                    endIcon={<ArrowForward />}
                    sx={{
                      mt: 2,
                      px: 5,
                      py: 1.2,
                      borderRadius: 3,
                      fontWeight: 700,
                      fontSize: "1rem",
                      textTransform: "none",
                      background:
                        "linear-gradient(135deg, #f77f00 0%, #fb8c00 100%)",
                      boxShadow: "0 8px 24px rgba(247,127,0,0.35)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 12px 32px rgba(247,127,0,0.45)",
                        background:
                          "linear-gradient(135deg, #e65100 0%, #f77f00 100%)",
                      },
                    }}
                  >
                    Okay
                  </Button>
                </Stack>
              </DialogContent>
            </Box>
          </Zoom>
        </Box>
      </Fade>
    </Dialog>
  );
};

export default CreateSuccessfulTimeTable;
